import React from "react";
import RaisedButton from "material-ui/RaisedButton";

export const ItemComponent = ({ text, image, handleProductClick }) => {
  let backgroundImage;
  try {
    backgroundImage = require("../../images/" + image);
  } catch (ex) {
    backgroundImage = require("../../images/noimage.png");
  }

  const buttonStyle = {
    height: 200,
    width: 150,
    margin: 20,
    display: "inline-block",
    position: "relative"
    //   background: `url(${backgroundImage})`,
  };

  const imgStyle = {
    width: 150,
    height: 200,
    background: `url(${backgroundImage}) top center/contain no-repeat`
  };

  const nameStyle = {
    position: "absolute",
    bottom: 0,
    left: 0,
    width: 150,
    height: 45,
    lineHeight: "45px",
    textAlign: "center",
    color: "white",
    backgroundColor: "rgba(100,100,100,0.6)"
  };

  return (
    <RaisedButton
      className="item"
      style={buttonStyle}
      onClick={() => handleProductClick()}
    >
      <div style={imgStyle} />
      <span className="item-figcaption" style={nameStyle}>
        {text}
      </span>
    </RaisedButton>
  );
};



// WEBPACK FOOTER //
// ./src/components/presentational/Item.js